// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"7bb72e0b","453":"aa77ffd1"}[chunkId] + ".chunk.js";
};